import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import { APPLICATIONS_ENDPOINT, getBaseUrl, POSITIONS_ENDPOINT } from '../../constants';

import {
  normalizeApplication,
  normalizePosition,
  normalizePositions,
  toPositionPayload,
} from '../normalizers';

/**
 * Creates a new Person.
 * @Positions
 */
export class Positions {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Positions(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = POSITIONS_ENDPOINT;
    this.applications_endpoint = APPLICATIONS_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }
  /**
   * this function is to get All positions
   * @function getAllPosition
   ** @param {reqParam} default parameter
   */

  async getAllPosition(reqParam) {
    const queryString = queryBuilder(reqParam);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: normalizePositions(response?.data ?? []), meta: response?.meta };
  }
  /**
   * this function is to get All ApplicantStatsCount
   * @function getAllApplicantStatsCount
   ** @param {reqParam} default parameter
   */

  async getAllApplicantStatsCount(reqParams) {
    const { reqId, ...queryParams } = reqParams;
    const queryString = queryBuilder(queryParams);
    const url = `${this.base_url}${this.endpoint}/${reqId}/stats${queryString}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }
  /**
   * this function is to get position by Id
   * @function getPositionById
   ** @param {reqId} default parameter
   */

  async getPositionById(reqParams) {
    const { reqId, ...queryParams } = reqParams;
    const queryString = queryBuilder(queryParams);
    const url = `${this.base_url}${this.endpoint}/${reqId}${queryString}`;
    const response = await this.fetcher.getData(url);
    return normalizePosition(response?.data);
  }

  /**
   * this function is to get applications related to position by Id
   * @function getPositionKanbanById
   ** @param {object} reqParams parameter
   */

  async getPositionKanbanById(reqParams) {
    const { reqId, ...queryParams } = reqParams;
    const queryString = queryBuilder(queryParams);
    const url = `${this.base_url}${this.endpoint}/${reqId}${this.applications_endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return (response?.data ?? []).map(normalizeApplication);
  }

  /**
   * this function is to update position by Id
   * @function putPositionById
   ** @param {reqParams} default parameter
   */

  async putPositionById(reqParams) {
    const url = `${this.base_url + this.endpoint}/${reqParams.reqId}`;
    const response = await this.fetcher.putData(url, toPositionPayload(reqParams.reqBody));
    return normalizePosition(response?.data);
  }

  /**
   * this function is to update position by Id
   * @function putPositionStatusById
   ** @param {reqParams} default parameter
   */

  async putPositionStatusById(reqParams) {
    const { reqId, reqBody = {} } =
      typeof reqParams === 'object' && reqParams !== null
        ? reqParams
        : { reqId: reqParams, reqBody: {} };
    const url = `${this.base_url + this.endpoint}/${reqId}/status`;
    const payload = {
      status: reqBody.status,
      versionKey: reqBody.versionKey,
    };
    const response = await this.fetcher.putData(url, payload);
    return normalizePosition(response?.data);
  }
  /**
   * this function is to post position
   * @function postPosition
   ** @param {reqBody} default parameter
   */

  async postPosition(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, toPositionPayload(reqBody));
    return normalizePosition(response?.data);
  }

  /**
   * this function is to delete positions by Id
   * @function deletePositionById
   ** @param {reqId} default parameter
   */

  async deletePositionById(reqParams) {
    const url = `${this.base_url + this.endpoint}/${reqParams.reqId}`;
    const response = await this.fetcher.deleteData(url, toPositionPayload(reqParams.reqBody));
    return response;
  }
}

export const createPositions = () => Positions.getInstance();
